import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/*
    - ihoDesignSystem
*/
import { Container, Grid } from '@iho-design-system/Loader';

/*
    - component
*/
import HistoryComponent from '../components/request/History';
import ListComponent from '../components/request/List';
import ToolbarComponent from '../components/request/Toolbar';

/*
    - api
*/
import getAPI from '../api/get';

const Request = () => {

    /*
        - defaultData
    */
    const navigate = useNavigate();
    const urlParameters = useParams();
    const [requestData, setRequestData] = React.useState({
        userTickets: ''
    });
    const [selectedRequest, setSelectedRequest] = React.useState([]);
    const [toggleHistory, setToggleHistory] = React.useState(false);
    const [advancedSearchParameters, setAdvancedSearchParameters] = React.useState({
        RequestKey: -1,
        TicketStatus: -1,
        AddDate: ''
    });
    const [reloadRequest, setReloadRequest] = React.useState('');

    /*
        - fetchData
    */
    React.useEffect(() => {
        const fetchData = async () => {
            let userTicketsParameters = {
                ctrl: 'UserProfile',
                method: 'GetUserTickets',
                query: '?PageIndex=1&PageSize=10'
            }
            setRequestData({
                userTickets: await getAPI(userTicketsParameters),
            });
        }
        fetchData();
    }, [toggleHistory, reloadRequest]);

    /*
        - reloadRequestProps
    */
    const reloadRequestProps = (reloadRequestProps) => {
        setRequestData({
            userTickets: ''
        });
        setAdvancedSearchParameters('');
        setReloadRequest(reloadRequestProps);
    }

    /*
        - requestIdSearchProps
    */
    const requestIdSearchProps = async (requestIdSearchProps) => {
        let parameters = {
            ctrl: 'UserProfile',
            method: 'GetUserTickets',
            query: ''
        }
        parameters.query = `?PageIndex=1&PageSize=10&Code=${requestIdSearchProps}`
        setRequestData({
            ...requestData,
            userTickets: await getAPI(parameters)
        });
    }

    /*
        - advancedSearchProps
    */
    const advancedSearchProps = async (advancedSearchProps) => {
        let parameters = {
            ctrl: 'UserProfile',
            method: 'GetUserTickets',
            query: ''
        };
        parameters.query = `?PageIndex=1&PageSize=10&AddDate=${advancedSearchProps.AddDate}&TicketStatus=${+advancedSearchProps.TicketStatus === -1 ? '' : advancedSearchProps.TicketStatus}&RequestKey=${+advancedSearchProps.RequestKey === -1 ? '' : advancedSearchProps.RequestKey}`;
        console.log(parameters)
        setAdvancedSearchParameters(advancedSearchProps);
        setRequestData({
            ...requestData,
            userTickets: await getAPI(parameters)
        });
    }

    /*
        - historyProps
    */
    const selectedRequestProps = (selectedRequestProps) => {
        setSelectedRequest(selectedRequestProps);
        navigate('/request/history');
        setToggleHistory(true);
    }

    /*
        - toggleHistoryProps
    */
    const toggleHistoryProps = () => {
        navigate('/request');
        setToggleHistory(false);
    }

    React.useEffect(() => {
        if (Object.keys(urlParameters).length !== 0) {
            setToggleHistory(true);
        } else {
            setToggleHistory(false);
        }
    }, [urlParameters])

    /*
        - paginationProps
    */
    const paginationProps = async (paginationProps) => {
        let parameters = {
            ctrl: 'UserProfile',
            method: 'GetUserTickets',
            query: ''
        };
        if (Math.ceil(requestData.userTickets.data.TotalItems / requestData.userTickets.data.PageSize) >= requestData.userTickets.data.PageIndex + paginationProps && (requestData.userTickets.data.PageIndex + paginationProps) >= 1) {
            parameters.query = `?PageIndex=${requestData.userTickets.data.PageIndex + paginationProps}&PageSize=10&AddDate=${advancedSearchParameters.AddDate}&TicketStatus=${advancedSearchParameters.TicketStatus === -1 ? '' : advancedSearchParameters.TicketStatus}&RequestKey=${advancedSearchParameters.RequestKey === -1 ? '' : advancedSearchParameters.RequestKey}`
            setRequestData({
                ...requestData,
                userTickets: await getAPI(parameters)
            });
        }
    }

    /*
        - componentData
    */
    let listData = [];
    listData.userTickets = requestData.userTickets;

    let historyData = [];
    historyData.selectedRequest = selectedRequest;

    return (
        <React.Fragment>
            <Container
                size='lg'>
                <Grid>
                    <Grid.Wrapper>
                        {!toggleHistory &&
                            <Grid.Item
                                className={`pr-0 pl-0`}
                                size='col-12'>
                                <ToolbarComponent
                                    requestIdSearchProps={requestIdSearchProps}
                                    advancedSearchProps={advancedSearchProps}
                                    reloadRequestProps={reloadRequestProps} />
                            </Grid.Item>
                        }
                        {!toggleHistory &&
                            <Grid.Item
                                className={`pr-0 pl-0`}
                                size='col-12'>
                                <ListComponent
                                    props={listData}
                                    selectedRequestProps={selectedRequestProps}
                                    paginationProps={paginationProps} />
                            </Grid.Item>
                        }
                        {toggleHistory &&
                            <Grid.Item
                                size='col-12'>
                                <HistoryComponent
                                    props={historyData}
                                    toggleHistoryProps={toggleHistoryProps} />
                            </Grid.Item>
                        }
                    </Grid.Wrapper>
                </Grid>
            </Container>
        </React.Fragment>
    );

}

export default Request;